<template>
  <!-- 线上考试 -->
  <div class="index-container" v-loading="loading">
    <div class="index-content">
      <div class="nav-box">
        首页 > 大健康人才培训 > 在线考试
        <span>> 线上考试</span>
      </div>
      <div class="module-box">
        <div class="test-name">{{ detail.title }}</div>
        <div class="test-detail">
          试卷说明：
          <!-- <span>5</span> 大题，
          <span>45</span> 小题，满分
          <span>100</span> 分，考试时间
          <span>150</span> 分钟-->
          <span>{{ detail.detail ? detail.detail : "暂无说明" }}</span>
        </div>
      </div>
      <div class="test-content">
        <div class="left-test">
          <div class="question-list-box" v-for="(item, index) in questionList" :key="'ques' + index" :id="item.uuid">
            <div class="list-title">{{ index + 1 }}. {{ item.title }}</div>
            <div class="answer-text" v-for="(obj, key) in item.option" :key="'option' + key">{{ key }}. {{ obj }}</div>
            <div class="select-box" :class="item.type === 3 ? 'answer-box' : ''">
              <div class v-if="item.type === 2">
                <el-checkbox-group v-model="item.answer" @change="answerSelect(item.answer, index)">
                  <el-checkbox v-for="(select, key) in item.option" :key="'select' + key" :label="key">{{
                    key
                  }}</el-checkbox>
                </el-checkbox-group>
              </div>
              <div v-if="item.type === 1">
                <el-radio-group v-model="item.answer" @change="answerSelect(item.answer, index)">
                  <el-radio
                    @click.native.prevent="clickitem(key, item)"
                    v-for="(radio, key) in item.option"
                    :key="'radio' + key"
                    :label="key"
                    >{{ key }}</el-radio
                  >
                </el-radio-group>
              </div>
              <div v-if="item.type === 3">
                <el-upload
                  ref="my-upload"
                  class="upload-demo"
                  :action="uploadUrl"
                  :limit="1"
                  :on-success="successUpload"
                  @clearFiles="clearFiles(index)"
                  :on-preview="previewFile"
                  :file-list="item.answer"
                >
                  <el-button size="small" @click="getFileIndex(index)" type="primary">点击上传</el-button
                  >（最多上传一个文件）
                  <el-button v-if="item.answer.length > 0" size="small" @click="deleteFile(index)">删除文件</el-button>
                </el-upload>
                <!-- <el-input
                  type="textarea"
                  placeholder="请作答"
                  v-model="item.answer"
                  @input="answerSelect(item.answer, index)"
                ></el-input>-->
              </div>
              <!-- <div class="right-text">
                错误人数：
                <span>{{item.no_pass}}</span> 错误率：
                <span>{{item.no_pass_rate}}</span>
              </div>-->
            </div>
          </div>
        </div>
        <div class="right-question">
          <div class="right-title-box">
            <div class="r-title">答题卡</div>
            <time-clock
              :autoStart="autoStart"
              :sendSync="sendSync"
              :defaultVal="defaultVal"
              @getDataFromChild="getDataFromChild"
            ></time-clock>
          </div>
          <div class="card-box">
            <div
              class="card-list"
              :class="item.answer.length > 0 ? 'card-active' : ''"
              v-for="(item, index) in questionList"
              :key="index"
              @click="selectQuestion(item, index)"
            >
              {{ item.list_order }}
            </div>
          </div>
          <el-pagination
            background
            :pager-count="5"
            layout="prev, pager, next"
            :current-page="page_index"
            :page-size="page_size"
            :total="listTotal"
            @current-change="handleCurrentChange"
          ></el-pagination>
          <div class="submit-button" @click="submitTest">提交试卷</div>
        </div>
      </div>
    </div>
    <el-dialog class="form-box" :visible.sync="dialogVisible" width="600PX">
      <video
        oncontextmenu="return false;"
        autoplay
        class="dialog-img"
        v-if="urlType == 'mp4'"
        :src="imgUrl + previewUrl"
      ></video>
      <div v-else class="dialog-img" :style="{ backgroundImage: 'url( ' + imgUrl + previewUrl + ')' }"></div>
    </el-dialog>
  </div>
</template>
<script>
import api from "../api/api";
import timeClock from "@/components/timeClock.vue";
import { upload_url } from "../api/index";
import { imgUrl } from "../api/index";

export default {
  name: "testOnline",
  components: {
    timeClock,
  },
  data() {
    return {
      imgUrl: imgUrl,
      questionList: [],
      cardIndex: 0,
      detail: {},
      paper_uuid: "",
      totalTimer: "",
      autoStart: true,
      sendSync: true,
      page_index: 1,
      page_size: 20,
      listTotal: 0,
      submitTime: "",
      defaultVal: sessionStorage.getItem("timer") ? parseInt(sessionStorage.getItem("timer")) : 0,
      totalList: [],
      loading: true,
      startTime: "",
      end_time: "",
      uploadUrl: upload_url, // 上传地址
      fileIndex: undefined,
      dialogVisible: false,
      previewUrl: "",
      urlType: "",
    };
  },
  created() {
    let year = new Date().getFullYear();
    let month = new Date().getMonth() + 1;
    let date = new Date().getDate();
    let h = new Date().getHours();
    let m = new Date().getMinutes();
    let mm = new Date().getSeconds();
    this.startTime = year + "-" + month + "-" + date + " " + h + ":" + m + ":" + mm;
    const value = this.$route.query;
    console.log(value);
    if (value) {
      this.paper_uuid = value.id;
      this.getList();
    }
  },
  mounted() {
    scrollTo(0, 0);
  },
  methods: {
    //   上传后预览
    previewFile(file) {
      console.log(file);
      let url = file.name.split(".");
      console.log(url);
      this.urlType = url[1];
      this.previewUrl = file.response.result;
      this.dialogVisible = true;
    },
    getFileIndex(index) {
      console.log(index);
      this.fileIndex = index;
    },
    fileChange(file, fileList) {
      console.log(file, fileList);
    },
    deleteFile(index) {
      this.questionList[index].answer = [];
    },
    // 上传成功
    successUpload(res, file, fileList) {
      console.log(res, file, fileList);
      let fileArr = fileList;
      if (res.result) {
        let list = [];
        // fileArr.map(ele => {
        //   console.log(ele.response.result);
        //   list.push(ele.response.result);
        // });
        list.push(res.result);
        console.log(list);
        this.$message.success("上传成功！");
        this.questionList[this.fileIndex].answer = list;
        console.log(this.questionList);
      } else {
        this.$message.warning("上传失败！");
      }
    },
    clickitem(key, item) {
      console.log(key, item);
      if (key === item.answer) {
        item.answer = "";
      } else {
        item.answer = key;
      }
    },
    getDataFromChild(data, time) {
      this.totalTimer = data;
      this.submitTime = time;
      //   console.log(time);
      this.end_time = time;
      sessionStorage.setItem("timer", parseInt(data));
    },
    answerSelect(val, index) {
      console.log(val, index);
      // this.questionList[index].answer = [];
      if (val) {
        this.questionList[index].answer = val;
      } else {
        this.questionList[index].answer = [];
      }
    },
    // 页码改变
    handleCurrentChange(val) {
      console.log(val + "list");
      sessionStorage.setItem(this.page_index + "list", JSON.stringify(this.questionList));
      this.page_index = val;
      if (sessionStorage.getItem(val + "list")) {
        this.questionList = JSON.parse(sessionStorage.getItem(val + "list"));
      } else {
        this.getList();
      }
      console.log(this.questionList);

      //   if (sessionStorage.getItem(val - 1 + 'list')) {
      //     sessionStorage.setItem(
      //       val - 1 + 'list',
      //       JSON.stringify(this.questionList)
      //     );
      //   } else {
      //   if (val !== 1) {
      //     sessionStorage.setItem(
      //       val - 1 + 'list',
      //       JSON.stringify(this.questionList)
      //     );
      //   } else {
      //     console.log(val);
      //     sessionStorage.setItem(
      //       val + 1 + 'list',
      //       JSON.stringify(this.questionList)
      //     );
      //   }

      //   }
    },
    getList() {
      const params = {
        page_index: this.page_index,
        page_size: this.page_size,
        paper_uuid: this.paper_uuid,
      };
      api.getSubjectList(params).then((res) => {
        console.log("res", res);

        if (res.result.last_uuid && this.$route.query.from != "retry") {
          return this.$router.push(`/resultOnline?id=${res.result.last_uuid}`);
        }

        if (res.result.paper) {
          this.detail = res.result.paper;
          let arr = res.result.data;
          arr.map((ele) => {
            // if (ele.type === 2) {
            ele.answer = [];
            // } else {
            //   ele.answer = "";
            // }
          });
          this.questionList = arr;
          this.listTotal = res.result.total;
          this.loading = false;
          console.log(this.questionList);
        } else {
          this.$message.warning("出错了");
        }
      });
    },
    selectQuestion(item, index) {
      const scrollIntoViewOptions = {
        behavior: "smooth",
        block: "center",
      };
      document.getElementById(item.uuid).scrollIntoView(scrollIntoViewOptions);
    },
    submitTest() {
      this.loading = true;
      let dataArray = [];
      let j = Math.ceil(this.listTotal / 20);
      let arr = [];
      for (let i = 0; i < j; i++) {
        console.log(JSON.parse(sessionStorage.getItem(i + "list")));
        if (JSON.parse(sessionStorage.getItem(i + "list"))) {
          arr.push.apply(arr, JSON.parse(sessionStorage.getItem(i + "list")));
        }
      }
      console.log(arr);
      console.log(this.questionList);
      arr.push(...this.questionList);
      console.log(arr);
      arr.forEach((item) => {
        let obj = {};
        let q = [];
        q.push(item.answer);
        obj = {
          subject_uuid: item.uuid,
          correct: Array.isArray(item.answer) ? item.answer : q,
        };
        dataArray.push(obj);
      });
      let year = new Date().getFullYear();
      let month = new Date().getMonth() + 1;
      let date = new Date().getDate();
      let h = new Date().getHours();
      let m = new Date().getMinutes();
      let mm = new Date().getSeconds();
      const params = {
        paper_uuid: this.paper_uuid,
        exam_time: this.submitTime,
        data: dataArray,
        start_time: this.startTime,
        end_time: year + "-" + month + "-" + date + " " + h + ":" + m + ":" + mm,
      };
      console.log(params);
      debugger;
      api.onlineExam(params).then((res) => {
        console.log(res);
        if (res.result) {
          this.loading = false;
          this.$message.success("提交成功");
          sessionStorage.clear();
          this.$router.push({
            path: "/resultOnline",
            query: { id: res.result.uuid },
          });
        }
      });
    },
  },
  destroyed() {
    sessionStorage.removeItem("timer");
  },
};
</script>
<style lang="scss" scoped>
.index-container {
  margin-top: 122px;
  background-color: #f8f7f6;
}
.index-content {
  width: 72%;
  padding: 50px 0;
  margin: 0 auto;
}
.nav-box {
  padding-bottom: 40px;
  font-size: 16px;
  color: #333333;
  span {
    color: #7d7d7d;
  }
}
.module-box {
  padding: 40px 42px 32px;
  margin-bottom: 30px;
  background-color: #ffffff;
  .test-name {
    padding-bottom: 20px;
    font-size: 26px;
    color: #333333;
    font-weight: 600;
  }
  .test-detail {
    font-size: 16px;
    color: #777777;
    span {
      color: #333333;
    }
  }
}
.test-content {
  display: flex;
  min-height: 400px;
  // justify-content: space-between;
}
.left-test {
  width: 64%;
  background-color: #ffffff;
  .question-list-box {
    padding: 44px 34px 34px;
    margin-bottom: 24px;
    background-color: #ffffff;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .list-title {
    padding-bottom: 30px;
    font-size: 16px;
    font-weight: 600;
  }
  .answer-text {
    padding-bottom: 14px;
    padding-left: 22px;
  }
  .select-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 16px;
  }
  .answer-box {
    display: block;
  }
  .right-text {
    font-size: 12px;
    color: #777777;
    span {
      color: #333333;
    }
  }
  /deep/ {
    .el-radio__inner,
    .el-checkbox__inner {
      width: 18px;
      height: 18px;
      line-height: 18px;
      border-radius: 2px;
      border-color: #979797;
    }
    .el-checkbox__inner::after {
      left: 6px;
      top: 3px;
    }
    .el-radio__input.is-checked .el-radio__inner,
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      border-color: #409eff;
    }
  }
}
.right-question {
  position: relative;
  // width: 34%;
  width: 468px;
  flex-shrink: 0;
  padding: 30px 25px;
  margin-left: 30px;
  background-color: #ffffff;
  .right-title-box {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ececec;
    .r-title {
      width: 60px;
      padding-bottom: 16px;
      font-size: 20px;
      color: #f1a373;
      font-weight: 600;
      border-bottom: 3px solid #f1a373;
    }
    .time {
      font-size: 18px;
      color: #666666;
    }
  }
  .card-box {
    display: flex;
    flex-wrap: wrap;
    padding: 40px 8px 18px;
  }
  .card-list {
    width: 34px;
    height: 34px;
    margin: 0 14px 28px;
    font-size: 18px;
    color: #999999;
    line-height: 34px;
    text-align: center;
    background-color: #ffffff;
    border-radius: 50%;
    border: 1px solid #c1c1c1;
    cursor: pointer;
    &:hover {
      color: #ffffff;
      background-color: #e6e6e6;
      border-color: #e8e8e8;
    }
  }
  .card-active {
    color: #ffffff;
    background-color: #e6e6e6;
    border-color: #e8e8e8;
  }
  .submit-button {
    position: absolute;
    bottom: 30px;
    width: 80%;
    margin: 0 auto;
    font-size: 20px;
    color: #ffffff;
    line-height: 64px;
    text-align: center;
    background-color: #f1a373;
    border-radius: 45px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}

/deep/ {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fb6d0a;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #ffffff;
    background-color: #fb6d0a;
  }
  .el-pagination {
    // margin-bottom: 80PX;
    text-align: center;
    // button {
    //   width: 42PX;
    //   height: 42PX;
    // }
  }
  .el-upload-list__item .el-icon-close {
    display: none !important;
  }
  //   .el-pager li {
  //     width: 42PX;
  //     height: 42PX;
  //     line-height: 42PX;
  //   }
}
.form-box {
  video {
    width: 100%;
    height: 100%;
    // object-fit: fill;
  }

  .dialog-img {
    width: 90%;
    height: 445px;
    margin: 0 auto 26px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/testOnline.vue